<!--销售订单列表  -->
<template>
    <div class="business-content-main" v-loding="isBatchPrinting">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="addNew(0)"
                    v-if="permission.addOrder">{{ permission.addOrder }} (F1)</el-button>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary"
                    @click="showSearchDialog">查询 (F2)</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="add(3)"
                    v-if="permission.add">{{ permission.add }} (F3)</el-button>
                <el-button v-if="permission.VINSearch" size="small" type="primary" class="search-btn"
                    @click="vinSearch">{{ permission.VINSearch }} (F4)</el-button>
                <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer"
                    class="search-btn btn-primary" @click="print()">{{
                        permission.print
                    }}</el-button>
                <el-button v-if="permission.printPreview && !isDefaultSet" size="small" icon="el-icon-view"
                    class="search-btn btn-primary" @click="printPreview()">{{
                        permission.printPreview
                    }}</el-button>
                <el-button v-if="(permission.printPreview || permission.print) && isDefaultSet" size="small"
                    icon="el-icon-printer" class="search-btn btn-primary" @click="printPreview()">打印</el-button>
                <el-button v-if="permission.btachPrintOrder" size="small" icon="el-icon-printer"
                    class="search-btn btn-primary" @click="batchPrint()">{{
                        permission.btachPrintOrder
                    }}</el-button>
                <el-button v-if="permission.printEng" size="small" icon="el-icon-printer" class="search-btn btn-primary"
                    @click="printEng()">{{
                        permission.printEng
                    }}</el-button>
                <el-button v-if="permission.export" size="small" icon="el-icon-download" class="search-btn btn-primary"
                    @click="exportForm()">{{
                        permission.export
                    }}</el-button>
                <el-button v-if="permission.exportEng" size="small" icon="el-icon-download"
                    class="search-btn btn-primary" @click="exportEngForm()">{{
                        permission.exportEng
                    }}</el-button>
                <el-button v-if="permission.importOrder" size="small" class="search-btn btn-primary"
                    @click="gotoImportPage">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.importOrder }}
                </el-button>
                <el-button v-if="permission.importCreateOrder" size="small" class="search-btn btn-primary"
                    @click="gotoImportCreatePage">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.importCreateOrder }}
                </el-button>
                <el-upload :action="upLoadUrl" :headers="headers" :on-error="uploadErr" accept=".xls, .xlsx"
                    :show-file-list="false" :before-upload="beforeUpload" :on-success="uploadSuccess"
                    v-loading.fullscreen.lock="upLoading" v-if="permission.importCYOrder" style="margin: 0 10px">
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn" type="warning"> {{
                        permission.importCYOrder }}</el-button>
                </el-upload>
                <el-upload :action="upLoadUrl2" :headers="headers" :on-error="uploadErr" accept=".xls, .xlsx"
                    :show-file-list="false" :before-upload="beforeUpload" :on-success="uploadSuccess"
                    v-loading.fullscreen.lock="upLoading" v-if="permission.importJCOrder" style="margin: 0 10px">
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn" type="warning"> {{
                        permission.importJCOrder }}</el-button>
                </el-upload>
                <el-upload :action="upLoadUrl3" :headers="headers" :on-error="uploadErr" accept=".xls, .xlsx"
                    :show-file-list="false" :before-upload="beforeUpload" :on-success="uploadSuccess"
                    v-loading.fullscreen.lock="upLoading" v-if="permission.importCQDJOrder" style="margin: 0 10px">
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn" type="warning"> {{
                        permission.importCQDJOrder }}</el-button>
                </el-upload>
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="history()"
                    v-if="permission.history">{{
                        permission.history
                    }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()"
                    v-if="permission.searchAP">搜索配件</el-button>
                <el-button v-if="permission.total" size="small" icon="el-icon-s-data" class="search-btn btn-primary"
                    @click="showCount">合计</el-button>
                <el-button v-if="permission.autoPrintOrder" type="primary" size="small" icon="el-icon-printer"
                    class="search-btn" @click="autoPrint()">自动打印</el-button>
                <el-button size="small" icon="el-icon-share" class="search-btn btn-primary" @click="appletCode()"
                    v-if="permission.appletCode">{{
                        permission.appletCode
                    }}</el-button>
            </div>
            <!-- <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr + (isExObj('TotalBillingPrice') ? (sepStr ? ' ；' + sepStr : '') : '') }}</span>
                    </div>
                </div>
            </div> -->
            <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn sales-order-table">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" ref="multipleTable"
                @selection-change="handleSelectionChange" border="" style="width: 100%" @cell-dblclick="handleDBClick"
                :tableCode="tableCode" @sort-change="sortChange" :row-key="getRowKeys" v-loading="loading"
                :summary-method="getSummaries" show-summary>
                <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                <template v-for="(col, index) in columnShowSets">
                    <el-table-column v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                        :sortable="col.IsSort ? 'custom' : false" header-align :prop="col.ColumnCode"
                        :class-name="col.ColumnCode === 'OrderCode' ? 'ordercode-column' : ''"
                        v-if="col.ColumnCode == 'OrderCode'" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <img src="@/assets/images/chong.png" title="需要冲减"
                                style="width: 20px; height: 20px; margin-right: 3px" v-if="scope.row.IsDeduct" />
                            <img src="@/assets/images/union.png" title="联盟订单" style="width: 20px; height: 20px"
                                v-if="scope.row.IsUnionOrder" />
                            <img src="@/assets/images/agent.png" title="联盟代发单（联盟发）" style="width: 20px; height: 20px"
                                v-if="scope.row.IsMyAgentOrder" />
                            <img src="@/assets/images/cusagent.png" title="联盟代发单(我发)" style="width: 20px; height: 20px"
                                v-if="scope.row.IsCusAgentOrder" />
                            <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger"
                                v-if="scope.row.PrintedCount > 0">
                                <el-tag @click="showOrderPreview(scope.row)" class="codetag"> {{ scope.row.OrderCode
                                }}</el-tag>
                            </el-badge>
                            <el-tag v-if="scope.row.PrintedCount == 0" @click="showOrderPreview(scope.row)"
                                class="codetag"> {{ scope.row.OrderCode }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                        :sortable="col.IsSort ? 'custom' : false" header-align :prop="col.ColumnCode"
                        show-overflow-tooltip v-else-if="col.ColumnCode == 'CollectionStateName'">
                        <template slot-scope="scope">
                            <i v-if="scope.row.CollectionStateName == '已收款'" class="c-active">{{
                                scope.row.CollectionStateName }}</i>
                            <i v-else>{{ scope.row.CollectionStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                        :sortable="col.IsSort ? 'custom' : false" header-align :prop="col.ColumnCode"
                        show-overflow-tooltip v-else-if="col.ColumnCode == 'WarehouseName'">
                        <template slot-scope="scope">
                            {{ scope.row.WarehouseName }}
                            <span style="color: #8492a6" v-if="scope.row.WarehouseType == 1">(前置仓)</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                        :sortable="col.IsSort ? 'custom' : false" header-align :prop="col.ColumnCode"
                        show-overflow-tooltip v-else-if="col.ColumnCode == 'OutWarehouseStateName'">
                        <template slot-scope="scope">
                            <i v-if="scope.row.OutWarehouseStateName == '已出仓'" class="out-active">{{
                                scope.row.OutWarehouseStateName }}</i>
                            <i v-else-if="scope.row.OutWarehouseStateName == '部分出仓'" class="cancel-active">{{
                                scope.row.OutWarehouseStateName }}</i>
                            <i v-else>{{ scope.row.OutWarehouseStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                        :sortable="col.IsSort ? 'custom' : false" header-align :prop="col.ColumnCode"
                        show-overflow-tooltip v-else>
                    </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" :isCanSet="true" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.edit && scope.row.IsCanUpdate && !scope.row.IsUnionOrder && !scope.row.IsMyAgentOrder && !scope.row.IsCusAgentOrder"
                                title="编辑" size="mini" type="text" @click="add(2, scope.row)">{{ permission.edit
                                }}</el-button>
                            <el-button
                                v-if="permission.editOrder && scope.row.IsCanUpdate && !scope.row.IsUnionOrder && !scope.row.IsMyAgentOrder && !scope.row.IsCusAgentOrder"
                                title="编辑" size="mini" type="text" @click="addNew(2, scope.row)">{{ permission.editOrder
                                }}</el-button>
                            <el-button
                                v-if="permission.submit && scope.row.IsCanUpdate && !scope.row.IsUnionOrder && !scope.row.IsMyAgentOrder && !scope.row.IsCusAgentOrder"
                                title="提交" size="mini" type="text" @click="submitOrder(scope.row)">{{ permission.submit
                                }}</el-button>
                            <el-button v-if="
                                permission.UpdateOrderAfterSubmit &&
                                (scope.row.IsCanUpdateAfterSubmit || (priceCanBeEdit ? scope.row.IsCanCollect : false)) &&
                                !scope.row.IsUnionOrder &&
                                !scope.row.IsMyAgentOrder &&
                                !scope.row.IsCusAgentOrder
                            " title="修改订单" size="mini" type="text" @click="add(8, scope.row)">{{
                                permission.UpdateOrderAfterSubmit }}</el-button>
                            <el-button v-if="
                                permission.modifieOrder &&
                                (scope.row.IsCanUpdateAfterSubmit || (priceCanBeEdit ? scope.row.IsCanCollect : false)) &&
                                !scope.row.IsUnionOrder &&
                                !scope.row.IsMyAgentOrder &&
                                !scope.row.IsCusAgentOrder
                            " title="修改订单" size="mini" type="text" @click="addNew(8, scope.row)">{{
                                permission.modifieOrder }}</el-button>
                            <el-button v-if="permission.moneyIn && scope.row.IsCanCollect" title="申请收款" size="mini"
                                type="text" @click="add(5, scope.row)">{{
                                    permission.moneyIn
                                }}</el-button>
                            <el-button
                                v-if="permission.cancel && scope.row.IsCanCancel && !scope.row.IsUnionOrder && !scope.row.IsMyAgentOrder && !scope.row.IsCusAgentOrder"
                                title="取消" size="mini" type="text" style="color: orange" @click="cancel(scope.row)">{{
                                    permission.cancel }}</el-button>
                            <el-button v-if="permission.del && scope.row.IsCanDelete && !scope.row.IsUnionOrder"
                                title="删除" size="mini" type="text" style="color: red"
                                @click="del(scope.row)">删除</el-button>
                            <el-button v-if="
                                permission.rebuildSaleOrder &&
                                scope.row.IsCanRebuild &&
                                !scope.row.IsUnionOrder &&
                                !scope.row.IsMyAgentOrder &&
                                !scope.row.IsCusAgentOrder
                            " title="复制订单" size="mini" type="text" @click="add(7, scope.row)">{{
                                permission.rebuildSaleOrder }}</el-button>
                            <el-button v-if="
                                permission.copyOrder && scope.row.IsCanRebuild && !scope.row.IsUnionOrder && !scope.row.IsMyAgentOrder && !scope.row.IsCusAgentOrder
                            " title="复制订单" size="mini" type="text" @click="addNew(3, scope.row)">{{
                                permission.copyOrder }}</el-button>
                            <el-button
                                v-if="permission.quote && scope.row.OutWarehouseStateName == '已出仓' && !scope.row.IsMyAgentOrder && !scope.row.IsCusAgentOrder"
                                :title="permission.quote" size="mini" type="text" @click="add(7, scope.row)">{{
                                    permission.quote }}</el-button>
                            <el-button v-if="
                                permission.transQOrder &&
                                scope.row.IsCanTransToQuota &&
                                !scope.row.IsUnionOrder &&
                                !scope.row.IsMyAgentOrder &&
                                !scope.row.IsCusAgentOrder
                            " :title="permission.transQOrder" size="mini" type="text" @click="gotoQOrder(scope.row)">{{
                                permission.transQOrder }}</el-button>
                            <el-button v-if="
                                permission.transQOrder_v3 &&
                                scope.row.IsCanTransToQuota &&
                                !scope.row.IsUnionOrder &&
                                !scope.row.IsMyAgentOrder &&
                                !scope.row.IsCusAgentOrder
                            " :title="permission.transQOrder" size="mini" type="text"
                                @click="gotoQOrder_v3(scope.row)">{{ permission.transQOrder_v3 }}</el-button>
                            <el-button v-if="permission.opRecords" title="操作记录" size="mini" type="text"
                                @click="opRecords(scope.row)">{{
                                    permission.opRecords
                                }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination v-if="tableDataLength != 0" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]" :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="tableDataLength"></el-pagination>
        </div>
        <!--  打印  -->
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="870px">
            <div class="dialog-content" v-if="dialogVisible">
                <printSaleContent @closeDialog="closeDialog" :printIds="idList" :showDisc="showDisc" :isInit="true">
                </printSaleContent>
            </div>
        </el-dialog>
        <!-- 打印隐藏内容，用于直接打印 -->
        <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important"
            id="printDom" v-if="isRegister">
            <printSaleContent ref="printDom" @closeDialog="closeDialog" :printIds="idList" :showDisc="showDisc"
                :isInit="false">
            </printSaleContent>
        </div>
        <!--  打印英文版  -->
        <el-dialog :close-on-click-modal="false" title="打印英文销售单" :visible.sync="dialogPrintEngVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintEngVisible">
                <printEngContent @closeDialog="closePrintEngDialog" :printIds="idList"></printEngContent>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP canEdit="canNot" Source="0" @closeDialog="closeSearchDialog"></searchAP>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="合计" @close="closeStatisticsDialog"
            :visible.sync="statisticsVisible" width="500px">
            <div class="dialog-content" v-if="statisticsVisible">
                <statistics :countData="multipleSelection" type="sale"></statistics>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="销售单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <ordersLifes :OrderId="OrderId" :OrderType="0" @closeDialog="closeOrderLifesDialog"></ordersLifes>
            </div>
        </el-dialog>
        <el-dialog title="VIN快搜" :close-on-click-modal="false" :visible.sync="vinSearchVisible" append-to-body
            v-dialog-drag lock-scroll :modal="false" id="vin-search-dialog" style="margin-left: -500px" width="1000px">
            <div class="dialog-content" v-if="vinSearchVisible">
                <vinSearch ref="vinSearch" @closeDialog="
                    () => {
                        vinSearchVisible = false;
                    }
                "></vinSearch>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="销售订单搜索" :visible.sync="dialogSearchVisible" width="400px"
            append-to-body v-dialog-drag lock-scroll :modal="false" id="search-order-dialog"
            custom-class="search-item-dialog" style="margin-left: -170px">
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="客户名称">
                        <el-select ref="search_cus" style="width: 100%" size="small" v-model="searchData.Keyword" remote
                            filterable allow-create clearable placeholder="客户名称/电话" :remote-method="searchCustom"
                            v-select-scroll-more="searchCustomLoad">
                            <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName"
                                :value="item.EntpCusName">
                                <div class="name">
                                    {{ item.EntpCusName }}
                                    <span v-if="item.CallNum" class="phone">
                                        {{ ` ( 电话：${item.CallNum} )` }}
                                    </span>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售单号">
                        <el-input size="small" v-model.trim="searchData.OrderCode"
                            v-filter-special-char="searchData.OrderCode" placeholder="销售单号"></el-input>
                    </el-form-item>
                    <el-form-item label="出库仓库" v-if="isExObj('WarehouseName')">
                        <el-select size="small" style="width: 100%" v-model="searchData.WarehouseId" filterable
                            clearable @visible-change="wHVisibleChange($event)">
                            <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId"
                                :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1"
                                    style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支付方式" v-if="isExObj('PayTypeName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.PayType"
                            @visible-change="paytypeVisibleChange($event)">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text"
                                :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发货方式" v-if="isExObj('DeliTypeName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.DeliType"
                            @visible-change="delitypeVisibleChange($event)">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in deliTypeList" :key="item.Value" :label="item.Text"
                                :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单状态" v-if="isExObj('StateName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text"
                                :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开单部门" v-if="isExObj('OrgName')">
                        <el-select size="small" class="search-item" style="width: 100%" v-model="searchData.OrgId"
                            filterable clearable collapse-tags reserve-keyword
                            @visible-change="orgVisibleChange($event)" placeholder="请选择">
                            <el-option v-for="optionItem in orgSearchData" :key="optionItem.Id" :data-msg="optionItem"
                                :label="optionItem.Name" :value="optionItem.Id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="业务员" v-if="isExObj('SName')">
                        <el-select v-model="searchData.SId" size="small" style="width: 100%" filterable
                            placeholder="请选择" clearable>
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName"
                                :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="转化类型" v-if="isExObj('SourcesName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.Source" clearable
                            @visible-change="sourceVisibleChange($event)">
                            <el-option v-for="item in sourceList" :key="item.Value" :label="item.Text"
                                :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单来源" v-if="isExObj('CusSourcesName') && isUseSource">
                        <el-select style="width: 100%" size="small" v-model="searchData.CusSources" clearable
                            @visible-change="cusSourceVisibleChange($event)">
                            <el-option v-for="item in cusSourceList" :key="item.Value" :label="item.Text"
                                :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注" v-if="isExObj('Remark')">
                        <el-input size="small" v-model.trim="searchData.Remark"
                            v-filter-special-char="searchData.Remark" placeholder="请输入单据备注信息"></el-input>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker size="small" style="width: 100%" v-model="datetime1" type="daterange"
                            align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker size="small" style="width: 100%" v-model="datetime2" type="daterange"
                            align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交日期" v-if="isExObj('ConfirmTime')">
                        <el-date-picker size="small" style="width: 100%" v-model="datetime3" type="daterange"
                            align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" :picker-options="pickerOptions"
                            @change="onDate3TimeSelect"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="出库日期" v-if="isExObj('WHFinishTime')">
                        <el-date-picker size="small" style="width: 100%" v-model="datetime4" type="daterange"
                            align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" :picker-options="pickerOptions"
                            @change="onDate4TimeSelect"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <!--   分享销售单    -->
        <el-dialog :close-on-click-modal="false" title="分享销售单（可用于收款）" :visible.sync="appletCodeVisible" width="500px">
            <div class="dialog-content" v-if="appletCodeVisible">
                <div style="text-align: center; margin: 20px 0">
                    <img :src="QRImg" v-if="QRImg" />
                </div>
                <div style="text-align: center; margin: 30px 0 50px 0">
                    <p>
                        <i class="el-icon-download downExt" @click="downloadImg"></i>
                        截图或下载图片分享给客户
                    </p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import Vue from 'vue';
import breadcrumb from '@/components/common/breadcrumb';
import statistics from '@/components/common/statistics.vue';
import mixin from '@/mixins/mixin';
import printEngContent from '@/components/business/salesManage/printSalesEng';
import searchAP from '@/components/common/searchAP';
import ordersLifes from '@/components/common/ordersLifes';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import vinSearch from '@/components/business/goods/vinSearchGoods';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        printEngContent,
        searchAP,
        statistics,
        breadcrumb,
        elTableColumn,
        ordersLifes,
        vinSearch
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            appletCodeVisible: false,
            summaryStr: '',
            sepStr: '',
            datetime1: [],
            datetime2: [],
            datetime3: [],
            datetime4: [],
            orgSearchData: [],
            deliTypeList: [], // 发货方式列表
            tableCode: 'SaleOrderTable',
            userMsg: userMsg,
            statisticsVisible: false,
            multipleSelection: null,
            dialogVisible: false,
            showDisc: true,
            dialogPrintEngVisible: false,
            searchVisible: false,
            OrderId: '',
            OrderLifesVisible: false,
            priceCanBeEdit: false,
            idList: [],
            searchData: {
                PayType: '',
                State: '99',
                Keyword: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                SortProp: '',
                SortType: '',
                WarehouseId: '',
                Remark: '',
                Source: '',
                CusSources: '',
                DeliType: '',
                OrgId: '',
                page: 1,
                limit: this.commonPageSize
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            payWayList: [],
            SIdList: [],
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '正常', Value: '99' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '40' },
                { Text: '未收款', Value: '5' },
                { Text: '已收款', Value: '10' },
                { Text: '未出仓', Value: '15' },
                { Text: '已出仓', Value: '20' },
                { Text: '已完成', Value: '30' },
                { Text: '已取消', Value: '25' },
                { Text: '已全部退货', Value: '35' }
            ],
            sourceList: [],
            cusSourceList: [],
            columnShowSets: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            upLoading: false,
            upLoadUrl: '/api/EntpSaleOrder/UploadCYSalesOrderExcel',
            upLoadUrl2: '/api/EntpSaleOrder/UploadJCSalesOrderExcel',
            upLoadUrl3: '/api/EntpSaleOrder/UploadCQDJSalesOrderExcel',
            headers: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            isDefaultSet: true, //是否使用浏览器的打印功能
            isPreview: false, //是否出现预览界面
            askShowDisc: false, //询问是否打印订单优惠价格
            isStartSearch: false,
            dialogSearchVisible: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            isRegister: false,
            loading: false,
            isStopReq: false,
            vinSearchVisible: false,
            isCheckPrice: false,
            warehouseList: [],
            isUseSource: false, //是否启用销售开单显示来源
            isDefaultStaff: true,
            printQueue: [],       // 待打印队列
            currentPrintIndex: -1,// 当前正在打印的索引
            isBatchPrinting: false,// 是否正在批量打印中
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            if (this.$store.state.orderData && this.$store.state.orderData.Id) {
                if (this.$store.state.orderData.Refresh) {
                    this.$store.commit('updateOrderList', { Id: '', IsAdd: false, Refresh: false });
                    this.resetSearch(true);
                    this.getTableData();
                } else this.getSingleData(this.$store.state.orderData, true);
            }
            //this.getTableData();
        }
        //切换页面的时候不会清除当前页面缓存，但是其他页面也有相同字段，会串页面数据，还是把数据清空了不要误导
        this.$refs.multipleTable.clearSelection();
        this.idList = [];
        this.multipleSelection = null;
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        this.getSetsData().then(() => {
            this.getConfigByCodes();
        });
    },
    mounted() {
        let that = this;
        that.permission = that.$util.getPermission('salesOrder');
        //加载组件
        that.getPrintComponents();
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_cus.focus();
                });
            }
        }
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (that.dialogVisible || that.dialogPrintEngVisible || that.searchVisible || that.statisticsVisible || that.OrderLifesVisible) return;
            //F1
            if (key === 112) {
                e.preventDefault();
                that.addNew(0);
            }
            //F2
            if (key === 113) {
                e.preventDefault();
                if (that.SIdList.length <= 1) that.getSIdList();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
                return;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.add(3);
            }
            //F4
            if (key === 115) {
                e.preventDefault();
                that.vinSearch();
            }
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                } else if (that.vinSearchVisible) {
                    if (that.$refs.vinSearch) that.$refs.vinSearch.gotoCreatOrder();
                } else {
                    that.resetSearch();
                    that.getTableData();
                }
            }
            //ESC
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
                if (that.vinSearchVisible) {
                    that.vinSearchVisible = false;
                }
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        getConfigByCodes() {
            let that = this;
            let codes = ['syllqdysz', 'xwdyxxdxxyh', 'dyyl', 'xskdjzkcl', 'xgxsjg', 'djmrdtsj', 'ssckjbdylr', 'xsddly', 'ddlbmrbzsywy'];
            let isDefaultToday = false;
            that.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'syllqdysz':
                                that.isDefaultSet = result;
                                break;
                            case 'xwdyxxdxxyh': //询问是否打印订单优惠价格
                                that.askShowDisc = result;
                                break;
                            case 'dyyl': //是否出现预览界面
                                that.isPreview = result;
                                break;
                            case 'xgxsjg':
                                that.priceCanBeEdit = result;
                                break;
                            case 'djmrdtsj':
                                isDefaultToday = result;
                                break;
                            case 'ssckjbdylr': //开启检查销售价的限制
                                that.isCheckPrice = result;
                                break;
                            case 'xsddly': //是否启用销售开单显示来源
                                that.isUseSource = result;
                                break;
                            case 'ddlbmrbzsywy':
                                that.isDefaultStaff = result;
                        }
                    }
                    if (isDefaultToday && that.isExObj('CreateTime')) {
                        //当前设定的日期时间
                        let d = new Date();
                        let year1, month1, day1;
                        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date1 = new Date(year1, month1, day1, 0);
                        that.datetime1.push(date1);

                        //前一天设定的日期时间
                        let year2, month2, day2;
                        d.setTime(d.getTime());
                        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date2 = new Date(year2, month2, day2, 0);
                        that.datetime1.unshift(date2);

                        that.searchData.StartDate = date2;
                        that.searchData.EndDate = date1;
                    }

                    if (that.isDefaultStaff) {
                        that.searchData.SId = that.userMsg.EmployeeId;
                    }
                }
                that.getTableData();
            });
        },
        //获取中文打印模板
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printSaleContent', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printSaleContent', () => import('@/components/printModels/printSales'));
                    that.isRegister = true;
                }
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusOId;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        paytypeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.payWayList.length == 0) that.getPay();
            }
        },
        delitypeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.deliTypeList.length == 0) {
                    that.$util.getSendWay().then(data => {
                        that.deliTypeList = data;
                    });
                }
            }
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeStatisticsDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
        },
        showSearch() {
            this.searchVisible = true;
        },
        closeSearchDialog() {
            this.searchVisible = false;
        },
        // 跳转退货
        returns(row) {
            let searchParams = this.searchData;
            this.$util.setLocalStorage('salesOrder_searchParams', searchParams); //保存当前查询参数，返回页面时使用
            this.$router.push(`/salesManage/salesReturns/edit_v2?type=3&id=${row.EntpCusOId}`);
        },
        // 提交订单
        submitOrder(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要提交该销售单吗？',
                noMsg: true,
                confirm() {
                    if (that.isCheckPrice) {
                        that.checkPriceToConfirm(row);
                    } else {
                        that.submit(row);
                    }
                }
            });
        },
        submit(row) {
            let that = this;
            that.$util
                .axiosPost({
                    url: `/api/EntpSaleOrder/Submit?OrderId=${row.EntpCusOId}`
                })
                .then(() => {
                    that.$util.successMsg('提交成功');
                    that.getSingleData({ Id: row.EntpCusOId, IsAdd: false }, false);
                });
        },
        checkPriceToConfirm(row) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/CheckGoodsForSaveByOId',
                    data: {
                        OrderId: row.EntpCusOId
                    }
                })
                .then(res => {
                    if (res.data.IsNeedPwd) {
                        let remark = res.data.Content;
                        that.$prompt(remark, '请输入管理员的密码', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            // inputPattern: /.{1,18}/,
                            inputType: 'password'
                            // inputErrorMessage: '请输入18字以内的数字或字母！'
                        })
                            .then(({ value }) => {
                                that.$util
                                    .axiosPost({
                                        url: 'api/EntpSaleOrder/AuthForSaveOrder',
                                        data: {
                                            Pwd: value,
                                            OrderId: row.EntpCusOId
                                        }
                                    })
                                    .then(res => {
                                        that.$util.successMsg('授权成功');
                                        that.submit(row);
                                    })
                                    .catch(() => { });
                            })
                            .catch(() => { });
                    } else that.submit(row);
                })
                .catch(() => { });
        },
        // 导出
        exportForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let EntpCusOIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpSaleOrder/ExportSaleOrder',
                data: {
                    EntpCusOIds: EntpCusOIds
                }
            });
        },
        exportEngForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let EntpCusOIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpSaleOrder/ExportSaleOrderEng',
                data: {
                    EntpCusOIds: EntpCusOIds
                }
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusOId);
            }
            this.idList = idList;
        },
        closeDialogold(isPrint) {
            this.dialogVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.EntpCusOId == this.idList[0]) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        closeDialog(isPrint) {
            // 如果是批量打印模式
            if (this.isBatchPrinting) {
                setTimeout(() => {
                    this.processNextInQueue();
                }, 500);
                return;
            }

            this.dialogVisible = false;
            if (isPrint && this.idList && this.idList.length > 0) {
                this.tableData.forEach(item => {
                    if (item.EntpCusOId == this.idList[0]) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },

        closePrintEngDialog(isPrint) {
            this.dialogPrintEngVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.EntpCusOId == this.idList[0]) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 打印预览
        printPreview() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }

            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张销售单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张销售单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的销售单');
                return;
            }
            if (this.multipleSelection[0].StateName == '未提交') {
                this.$util.warningMsg('不能打印未提交的销售单');
                return;
            }
            this.batchIndex = 0;
            if (!this.askShowDisc || this.multipleSelection[0].DiscountAmount == 0) this.dialogVisible = true;
            else {
                this.showDisc = true;
                this.$confirm('是否打印显示优惠价？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                })
                    .then(() => {
                        this.showDisc = true;
                        this.dialogVisible = true;
                    })
                    .catch(() => {
                        this.showDisc = false;
                        this.dialogVisible = true;
                    });
            }
        },
        print() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }

            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张销售单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张销售单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的销售单');
                return;
            }
            if (this.multipleSelection[0].StateName == '未提交') {
                this.$util.warningMsg('不能打印未提交的销售单');
                return;
            }
            if (!this.askShowDisc || this.multipleSelection[0].DiscountAmount == 0) this.$refs.printDom.init(true);
            else {
                this.showDisc = true;
                this.$confirm('是否打印显示优惠价？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                })
                    .then(() => {
                        this.showDisc = true;
                        this.$refs.printDom.init(true);
                    })
                    .catch(() => {
                        this.showDisc = false;
                        this.$refs.printDom.init(true);
                    });
            }
        },
        // 打印英文版
        printEng() {
            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张销售单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张销售单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的销售单');
                return;
            }
            if (this.multipleSelection[0].StateName == '未提交') {
                this.$util.warningMsg('不能打印未提交的销售单');
                return;
            }
            this.dialogPrintEngVisible = true;
        },
        batchPrint() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }

            if (this.multipleSelection.length == 0) {
                this.$util.warningMsg('请选择销售单打印');
                return;
            }

            for (let index = 0; index < this.multipleSelection.length; index++) {
                const item = this.multipleSelection[index];
                if (item.StateName == '已取消' || item.StateName == '未提交') {
                    this.$util.warningMsg(`第${index + 1}行的订单【${item.OrderCode}】状态为${item.StateName}，不能打印`);
                    return;
                }
            }

            const startQueue = (isShowDisc) => {
                this.showDisc = isShowDisc;

                this.printQueue = this.multipleSelection.map(item => ({
                    id: item.EntpCusOId,
                    discountAmount: item.DiscountAmount,
                    code: item.OrderCode
                }));

                this.currentPrintIndex = -1;
                this.isBatchPrinting = true;
                this.loading = true;

                this.processNextInQueue();
            };

            if (!this.askShowDisc) {
                startQueue(false);
            } else {
                this.showDisc = true;
                this.$confirm('是否打印显示优惠价？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => startQueue(true))
                    .catch(() => startQueue(false));
            }
        },
        processNextInQueue() {
            this.currentPrintIndex++;

            if (this.currentPrintIndex >= this.printQueue.length) {
                this.restBatchPrint();
                return;
            }

            const currentItem = this.printQueue[this.currentPrintIndex];

            //这样插件好识别
            this.idList = [currentItem.id];

            if (!this.showDisc || currentItem.discountAmount == 0) {
                this.showDisc = false;
            } else {
                this.showDisc = true;
            }
            this.$nextTick(() => {
                if (this.$refs.printDom) {
                    this.$refs.printDom.init(true);
                } else {
                    this.restBatchPrint();
                }
            });
        },
        restBatchPrint() {
            this.isBatchPrinting = false;
            this.currentPrintIndex = -1;

            this.tableData.forEach(item => {
                if (this.printQueue.findIndex(x => x.id == item.EntpCusOId) > -1) {
                item.PrintedCount += 1;
                }
            });
            this.$refs.multipleTable.clearSelection();
            this.printQueue = [];
            this.idList = [];
            this.loading = false;
            this.$util.successMsg('批量打印完成！');
        },
        // 跳转编辑
        add(type, item) {
            let searchParams = this.searchData;
            this.$util.setLocalStorage('salesOrder_searchParams', searchParams); //保存当前查询参数，返回页面时使用
            let id = item ? item.EntpCusOId : '';
            this.$router.push(`/salesManage/salesOrder/edit_v2?type=${type}&id=${id}`);
        },
        addNew(type, item) {
            let searchParams = this.searchData;
            this.$util.setLocalStorage('salesOrder_searchParams', searchParams); //保存当前查询参数，返回页面时使用
            let id = item ? item.EntpCusOId : '';
            this.$router.push(`/salesManage/salesOrder/edit_v3?type=${type}&id=${id}`);
        },
        //转报价
        gotoQOrder(item) {
            this.$router.push(`/salesManage/quotation/edit_v2?type=4&sid=${item.EntpCusOId}`);
        },
        gotoQOrder_v3(item) {
            this.$router.push(`/salesManage/quotation/edit_v3?type=4&sid=${item.EntpCusOId}`);
        },
        // 跳转历史配件销售
        history() {
            let searchParams = this.searchData;
            this.$util.setLocalStorage('salesOrder_searchParams', searchParams); //保存当前查询参数，返回页面时使用
            this.$router.push('/salesManage/salesOrder/histories');
        },
        cancel(row) {
            let that = this;
            that.$confirm('确定要取消该销售单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$util
                    .axiosPost({
                        url: `/api/EntpSaleOrder/CancelSaleOrder?OrderId=${row.EntpCusOId}`
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('取消成功！');
                            that.getSingleData({ Id: row.EntpCusOId, IsAdd: false }, true);
                        }
                    });
            });
        },
        // 删除销售单
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该销售单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpSaleOrder/DelSaleOrder?OrderId=${row.EntpCusOId}`
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('删除成功！');
                                let idx = that.tableData.findIndex(f => f.EntpCusOId === row.EntpCusOId);
                                that.tableData.splice(idx, 1);

                                that.tableDataLength -= 1;
                            }
                        });
                }
            });
        },
        resetSearch(setDay = false) {
            this.searchData = {
                PayType: '',
                State: '99',
                Keyword: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                SortProp: '',
                SortType: '',
                WarehouseId: '',
                Remark: '',
                OrgId: '',
                Source: '',
                DeliType: '',
                CusSources: '',
                page: 1,
                limit: this.commonPageSize
            };

            if (this.isDefaultStaff) {
                this.searchData.SId = this.userMsg.EmployeeId;
            }

            this.datetime1 = [];
            this.datetime2 = [];
            this.datetime3 = [];
            this.datetime4 = [];
            this.$refs.multipleTable.clearSelection();

            if (setDay) {
                //当前设定的日期时间
                let d = new Date();
                let year1, month1, day1;
                [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date1 = new Date(year1, month1, day1, 0);
                this.datetime1.push(date1);

                //前一天设定的日期时间
                let year2, month2, day2;
                d.setTime(d.getTime());
                [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date2 = new Date(year2, month2, day2, 0);
                this.datetime1.unshift(date2);

                this.searchData.StartDate = date2;
                this.searchData.EndDate = date1;
            }
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        if (data.DataList) this.tableData = data.DataList;
                        else this.tableData = [];
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                            // this.summaryStr = data.SummaryStr;
                            // this.sepStr = data.SepStr; //开单合计
                            let exsum = this.isExObj('CalcAmount');
                            let exsep = this.isExObj('TotalBillingPrice')
                            if (exsum && exsep) {
                                this.summaryStr = data.SummaryStr + " ；" + data.SepStr;
                            } else if (exsum) {
                                this.summaryStr = data.SummaryStr
                            } else if (exsep) {
                                this.summaryStr = data.SepStr
                            }
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                let id = event.EntpCusOId;
                //保存当前查询参数，返回页面时使用
                this.$util.setLocalStorage('salesOrder_searchParams', this.searchData);
                this.$router.push(`/salesManage/salesOrder/check?id=${id}`);
            }
        },
        gotoImportPage() {
            this.$router.push('/salesManage/salesOrder/importOrdersExcel');
        },
        gotoImportCreatePage() {
            this.$router.push('/salesManage/salesOrder/importToCreateOrder');
        },
        opRecords(item) {
            let id = item ? item.EntpCusOId : '';
            if (id) {
                this.OrderId = id;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg('订单数据异常，请刷新后重新操作');
            }
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        },
        getSetsData() {
            return new Promise(resolve => {
                this.columnShowSets = [];
                this.$util
                    .getTBSetsForShow(this.tableCode)
                    .then(data => {
                        data.forEach(item => {
                            let colums = {
                                IsShow: item.IsShow,
                                Width: item.Width,
                                ColumnName: item.ColumnName,
                                ColumnCode: item.ColumnCode,
                                SortNum: item.SortNum,
                                IsSort: item.IsSort
                            };

                            this.columnShowSets.push(colums);
                        });
                        resolve();
                    })
                    .catch(err => {
                        resolve();
                    });
            });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        uploadSuccess(res) {
            if (res.errcode == 0) {
                this.$util.setLocalStorage('cySalesOrderData', res.data);
                this.upLoading = false;
                this.$router.push('/salesManage/salesOrder/importCYOrders');
            } else {
                this.$util.errorMsg(res.errmsg);
                this.upLoading = false;
            }
        },
        uploadErr(error) {
            this.upLoading = false;
            const result = JSON.parse(error.message);
            this.$util.errorMsg(result.message);
        },
        beforeUpload(file) {
            this.$util.clearLocalStorage('cySalesOrderData');
            this.upLoading = true;
        },
        showSearchDialog() {
            if (this.SIdList.length <= 1) this.getSIdList();
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        onDate4TimeSelect(val) {
            if (val != null) {
                this.searchData.WStartDate = val[0];
                this.searchData.WEndDate = val[1];
            } else {
                this.searchData.WStartDate = '';
                this.searchData.WEndDate = '';
            }
        },
        vinSearch() {
            this.vinSearchVisible = true;
        },
        autoPrint() {
            this.$router.push('/salesManage/salesOrder/autoPrintOrder');
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    that.$util.getWarehouse(1).then(data => {
                        that.warehouseList = data;
                    });
                }
            }
        },
        sourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.sourceList.length == 0) {
                    that.$util.getOrderSource().then(data => {
                        that.sourceList = data;
                    });
                }
            }
        },
        cusSourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusSourceList.length == 0) {
                    that.$util.getSalesOrderSources().then(data => {
                        if (data) {
                            that.cusSourceList = [...data, { Value: '-1', Text: '其他' }];
                        } else {
                            that.cusSourceList = [{ Value: '-1', Text: '其他' }];
                        }
                    });
                }
            }
        },
        appletCode() {
            let that = this;
            if (that.idList.length != 1) {
                that.$util.warningMsg('请选择一张销售单');
                return;
            }
            let orderData = that.tableData.find(e => e.EntpCusOId == that.idList[0]);
            if (!orderData) {
                that.$util.warningMsg('请选择一张销售单');
                return;
            }
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetSaleOrderWxaCode',
                    data: {
                        qCode: orderData.OrderCode
                    }
                })
                .then(response => {
                    let data = response.data;
                    if (data) {
                        that.QRImg = 'data:image/png;base64,' + response.data;
                        that.appletCodeVisible = true;
                    } else {
                        that.$util.warningMsg('请检查是否按要求操作，确认后重新提交');
                    }
                })
                .catch(() => { });
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        },
        downloadImg() {
            let that = this;
            let blob = that.$util.dataURLtoBlob(that.QRImg);
            const elink = document.createElement('a');
            // 设置下载文件名
            let orderData = that.tableData.find(e => e.QuoteId == that.idList[0]);
            let qCode = orderData.QCode;
            elink.download = `报价单二维码${qCode}.png`;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (
                    column.property == 'CallNum' ||
                    column.property == 'SName' ||
                    column.property == 'OrderCode' ||
                    column.property == 'PayTypeName' ||
                    column.property == 'UpdateTime' ||
                    column.property == 'CreateTime' ||
                    column.property == 'Remark' ||
                    column.property == 'ConfirmTime' ||
                    column.property == 'WHFinishTime'
                ) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        showOrderPreview(row) {
            this.idList = [];
            this.$refs.multipleTable.clearSelection();
            if (row) {
                this.idList.push(row.EntpCusOId);
                this.dialogVisible = true;
            }
        },
        getSingleData(param, isUpdate) {
            let that = this;
            that.$store.commit('updateOrderList', { Id: '', IsAdd: false });
            if (param.IsAdd && this.searchData.page == 1) {
                let topOrderId = that.tableData.length > 0 ? that.tableData[0].EntpCusOId : '';
                //获取单条数据，插入就行，删掉最后一条
                that.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetSigleOrderData',
                        data: {
                            PayType: that.searchData.PayType,
                            State: that.searchData.State,
                            Keyword: that.searchData.Keyword,
                            SId: that.searchData.SId,
                            OrderCode: that.searchData.OrderCode,
                            StartDate: that.searchData.StartDate,
                            EndDate: that.searchData.EndDate,
                            UStartDate: that.searchData.UStartDate,
                            UEndDate: that.searchData.UEndDate,
                            CStartDate: that.searchData.CStartDate,
                            CEndDate: that.searchData.CEndDate,
                            WStartDate: that.searchData.WStartDate,
                            WEndDate: that.searchData.WEndDate,
                            SortProp: that.searchData.SortProp,
                            SortType: that.searchData.SortType,
                            WarehouseId: that.searchData.WarehouseId,
                            Remark: that.searchData.Remark,
                            Source: that.searchData.Source,
                            CusSources: that.searchData.CusSources,
                            DeliType: that.searchData.DeliType,
                            OrgId: that.searchData.OrgId,
                            Id: param.Id,
                            IsUpdate: isUpdate,
                            TopOrderId: topOrderId,
                            Limit: that.searchData.limit
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            if (res.data.DataList && res.data.DataList.length > 0) {
                                for (let index = 0; index < res.data.DataList.length; index++) {
                                    const element = res.data.DataList[index];

                                    let idx = that.tableData.findIndex(f => f.EntpCusOId === param.Id);
                                    if (idx == -1) {
                                        if (that.tableData.length == that.searchData.limit) that.tableData.splice(-1, 1);
                                        that.tableData.unshift(element);
                                    }
                                }
                                that.tableDataLength += res.data.DataList.length;
                            }
                            if (isUpdate) that.summaryStr = res.data.SummaryStr;
                        }
                    })
                    .catch(() => { });
            } else {
                //获取单条，更新
                that.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetSigleOrderData',
                        data: {
                            PayType: that.searchData.PayType,
                            State: that.searchData.State,
                            Keyword: that.searchData.Keyword,
                            SId: that.searchData.SId,
                            OrderCode: that.searchData.OrderCode,
                            StartDate: that.searchData.StartDate,
                            EndDate: that.searchData.EndDate,
                            UStartDate: that.searchData.UStartDate,
                            UEndDate: that.searchData.UEndDate,
                            CStartDate: that.searchData.CStartDate,
                            CEndDate: that.searchData.CEndDate,
                            WStartDate: that.searchData.WStartDate,
                            WEndDate: that.searchData.WEndDate,
                            SortProp: that.searchData.SortProp,
                            SortType: that.searchData.SortType,
                            WarehouseId: that.searchData.WarehouseId,
                            Remark: that.searchData.Remark,
                            Source: that.searchData.Source,
                            CusSources: that.searchData.CusSources,
                            DeliType: that.searchData.DeliType,
                            OrgId: that.searchData.OrgId,
                            Id: param.Id,
                            IsUpdate: isUpdate,
                            Limit: that.searchData.limit
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            let idx = that.tableData.findIndex(f => f.EntpCusOId === param.Id);
                            that.tableData.splice(idx, 1, res.data.DataList[0]);

                            if (isUpdate) that.summaryStr = res.data.SummaryStr;
                        }
                    })
                    .catch(() => { });
            }
        }
    }
};
</script>
<style lang="less" scoped>
#vin-search-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999 !important;
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

#search-order-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

.codetag {
    font-size: 14px;
    border-style: none none none none;
    background-color: transparent;
    padding: 0;
    height: 11px;
    line-height: 12px;
    z-index: 999;
}
</style>
<style lang="less">
.sales-order-table {
    .el-table__row {
        td.ordercode-column {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
